<template>
    <public-layout>
        <div class="container py-5">
            <div class="head text-center mb-4">
                <h1>{{ canvasElement.name }}</h1>
            </div>

            <canvas-element-preview :element="canvasElement"/>

        </div>
    </public-layout>
</template>

<script>
import PublicLayout from "@/Layouts/PublicLayout";
import CanvasElementPreview from "@/Components/CanvasElement/CanvasElementPreview";
export default {
    name: "Show",
    components: {CanvasElementPreview, PublicLayout},
    props: ['canvasElement']
}
</script>

<style scoped>

</style>
